import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router'; 
import { SharedModule } from '../../shared/shared.module'; 
import { RentingInProgressComponent } from './renting-in-progress/renting-in-progress.component';
import { RentingEndedComponent } from './renting-ended/renting-ended.component';
import { RentingCanceledComponent } from './renting-canceled/renting-canceled.component';
import { RentingPendingComponent } from './renting-pending/renting-pending.component';
import { LocationInsuranceValueComponent } from './location-insurance-value/location-insurance-value.component';
import { NgxPaginationModule } from 'ngx-pagination';

export const routes: Routes = [ 
  { path: '', redirectTo: 'in-progress', pathMatch: 'full'},
  { path: 'pending', component: RentingPendingComponent, data: { breadcrumb: 'Liste des locations en attente de validation/paiement' } },
  { path: 'in-progress', component: RentingInProgressComponent, data: { breadcrumb: 'Liste des locations encours' } },
  { path: 'ended', component: RentingEndedComponent, data: { breadcrumb: 'Liste des locations Terminé' } },
  { path: 'canceled', component: RentingCanceledComponent, data: { breadcrumb: 'Liste des locations Refusé' } },
  { path: 'value-insurance', component: LocationInsuranceValueComponent, data: { breadcrumb: 'Valeur de l\'assurance par location' } },

];

@NgModule({
  declarations: [
    RentingInProgressComponent,
    RentingEndedComponent,
    RentingCanceledComponent,
    RentingPendingComponent,
    LocationInsuranceValueComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes), 
    SharedModule,
    NgxPaginationModule
  ]
})
export class LocationsModule { }
